import { DebtorSearchResultModel } from "../Types";

export const DebtorSearchModel: DebtorSearchResultModel = {
  data: [],
  isError: false,
  isLoading: false,
};
